import requester from "./requester";

/**
 * DingTalk Report API Service
 *
 * This module provides methods to interact with DingTalk report backend endpoints.
 * Used for syncing and managing DingTalk report data including upvotes.
 */

const { request } = requester;

/**
 * Sync user upvotes for DingTalk reports
 * @param {Object} params - Sync parameters
 * @param {number} params.userId - The local user ID to sync upvotes for
 * @param {string} [params.startTime] - Start time for the sync period (ISO 8601 format)
 * @param {string} [params.endTime] - End time for the sync period (ISO 8601 format)
 * @returns {Promise} Response with sync result including count of synced records
 */
export function syncUserUpvotes(params) {
  return request({
    url: '/dingtalk/reports/sync-user-upvotes',
    method: 'POST',
    data: params
  });
}

/**
 * Get DingTalk report statistics for a user
 * @param {Object} params - Query parameters
 * @param {number} params.userId - The user ID to get statistics for
 * @returns {Promise} Response with DingTalk report statistics
 */
export function getDingTalkStatistics(params) {
  return request({
    url: '/dingtalk/reports/my-statistics',
    method: 'GET',
    params
  });
}

/**
 * Get DingTalk report statistics summary for current user
 * @param {Object} params - Query parameters
 * @param {number} params.userId - The user ID to get statistics for
 * @returns {Promise} Response with DingTalk report statistics summary
 */
export function getMyDingTalkStatisticsSummary(params) {
  return request({
    url: '/dingtalk/reports/my-statistics',
    method: 'GET',
    params
  });
}

export default {
  syncUserUpvotes,
  getDingTalkStatistics,
  getMyDingTalkStatisticsSummary
};